import React, { Component } from 'react';
import MainLogo from "./icons/CyberSightsLogo.png";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from '@material-ui/core/IconButton';
import UserEmailAsk from './sessionPages/userMeeting/userEmailAsk/userEmailAsk';
import { isNullOrUndefined } from "util";
import MeetingV1Component from './sessionPages/userMeeting/MeetingV1';
import SalesMeetingFormSimpleComponent from './sessionPages/createMeeting/SalesMeetingFormSimple';
import * as AnalyticsSvc from '../common/AnalyticsSvc';
import * as Utils from '../common/utilSvc';
import * as Const from '../common/const';
import firebase from "firebase/app";
import "firebase/analytics";
import 'firebase/firestore';
import 'firebase/functions';

class PublicUserSessionComponent extends React.Component {
    
    constructor(props){

        super(props);

        this.state = {
            company: '',
            enteredCompany: '',
            userId: ''
        }

        this.canSave = this.canSave.bind(this);
        this.saveDetails = this.saveDetails.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.createMeetingFromMainSearch = this.createMeetingFromMainSearch.bind(this);
        this.sendCompanySearchToExcel = this.sendCompanySearchToExcel.bind(this);
        this.setUser = this.setUser.bind(this);

        this.getItemFromLocalStorageWrapper = this.getItemFromLocalStorageWrapper.bind(this);
        this.getUserIdFromLocal = this.getUserIdFromLocal.bind(this);
    }

    sendCompanySearchToExcel(company, userId){
        let row = {
            userId: userId, 
            company: company,
            date: Utils.formatDate(Date.now(), true)            
        }
        if(row.userId.length==0){
           // row.userId = null;
        }
        if(row.company.length==0){
            row.company = null;
        }
        AnalyticsSvc.logSearchInExcel(row);
    }

    handleChange(event, type, index){
        if(type=="company"){
            let company = this.state.company;
            company = event.target.value;
            if(!isNullOrUndefined(company)){
                company = company.replace("\n","");
            }
            this.setState({company: company});            
        }
    }

    canSave(){
        if(!isNullOrUndefined(this.state.company) && this.state.company.trim().length>0)
            return true;
        return false;
    }

    saveDetails(){
        /* this.setState({
            company: "",
            attendees: [""]
        }); */
        let company = this.state.company;
        if(company.trim().length > 0){
            company = company.charAt(0).toUpperCase() + company.slice(1);
            company = company.trim();
            this.setState({
                enteredCompany: company
            })        
            firebase.analytics().logEvent('company_lookup',{
                name: company,
                user_Id: this.state.userId
            });
            firebase.analytics().setUserProperties({company: company, user_Id: this.state.userId});
            this.sendCompanySearchToExcel(company, this.state.userId);
        }
    }

    createMeetingFromMainSearch(company, attendees){
        if(!isNullOrUndefined(company) && company.trim().length > 0){
            company = company.charAt(0).toUpperCase() + company.slice(1);
            company = company.trim();
            this.setState({
                enteredCompany: company,
                company: company
            })        
            firebase.analytics().logEvent('company_lookup',{
                name: company,
                user_Id: this.state.userId
            });
            firebase.analytics().setUserProperties({company: company, user_Id: this.state.userId});

            this.sendCompanySearchToExcel(company, this.state.userId);
        }
    }

    setUser(userId, avoidLocalStorage){
        this.setState({
            userId: userId
        });
        firebase.analytics().logEvent('userId_set',{
            user_Id: userId
        });
        if(this.state.company.trim().length>0){
            this.sendCompanySearchToExcel(this.state.company, userId)
        }

        if(avoidLocalStorage){
            //don't store in local
        }
        else{
            //store in local
            localStorage.setItem('userId_temp',userId);
            localStorage.setItem('time_temp',Date.now());
        }
    }

    getItemFromLocalStorageWrapper(key, defaultVal){
        if(!isNullOrUndefined(localStorage.getItem(key))){
            return localStorage.getItem(key);
        }
        return defaultVal;
    }

    getUserIdFromLocal(){
        //Local storage userId

        let userId = '', time = 0;
        userId = this.getItemFromLocalStorageWrapper('userId_temp',userId);
        time = this.getItemFromLocalStorageWrapper('time_temp',time);

        if(userId!='' && Math.abs(Date.now()-time)<14*Const.Day){
            this.setUser(userId, true);
        }
    }

    componentDidMount(){
        this.getUserIdFromLocal();
    }

    render(){
        let scope = this;
        return (
            <div>
                {!isNullOrUndefined(this.state.enteredCompany) && this.state.enteredCompany.length>0?
                    <div style={{display: 'block'}}>
                        <header className="toolbar" style={{zIndex:'1'}}>
                            <AppBar position="static" style={{background:'white'}}>
                                <Toolbar style={{background:'white'}}> 
                                    <img src={MainLogo} style={{width:'100px', marginTop:'4px', marginBottom:'4px'}}/>                    
                                    <div style={{margin:'10px', textAlign:'center', width:'40vw', fontSize:'12px'}}>
                                        <form>
                                            <label>
                                                <TextField 
                                                    type="text"
                                                    variant="outlined"
                                                    multiline
                                                    label = "Enter a company name"
                                                    placeholder = "Enter a company name"
                                                    value={this.state.company}
                                                    onChange={(e) => { this.handleChange(e,"company")}}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            if(scope.canSave()){
                                                                scope.saveDetails();
                                                            }
                                                        }
                                                    }}
                                                    rowsMax="2"
                                                    rowsMin="1"
                                                    InputProps={{
                                                        endAdornment: (
                                                        <InputAdornment>
                                                        {scope.canSave()?
                                                                <IconButton onClick={this.saveDetails}>
                                                                    <SearchIcon />
                                                                </IconButton>
                                                                :
                                                                null
                                                        }
                                                        </InputAdornment>
                                                        )
                                                    }}
                                                    style={{
                                                        background: 'white',
                                                        width:'95%',
                                                        maxWidth:'550px',
                                                        minWidth: '250px'
                                                        }}/>
                                            </label>
                                        </form>
                                    </div>
                                    <div style={{flexGrow: '1'}}></div>                                         
                                </Toolbar>
                            </AppBar>                   
                        </header>
                    </div>                
                    :
                    <div>
                        <div style={{textAlign:'center'}}>
                            <img src={MainLogo} style={{width:'300px', marginTop:'20px', marginBottom:'20px'}}/>
                        </div>
                        <div>
                            <SalesMeetingFormSimpleComponent
                                company = {this.state.company}
                                attendees={[]}
                                createMeeting = {this.createMeetingFromMainSearch}
                                hideAttendees = {true}
                                hideTitle = {true}
                                saveButtonText = {"Search"}
                                hideSaveButton = {true}
                                enterKeyCompanyEnabled = {true}
                                showSearchButtonAsIcon = {true}
                            />
                        </div>
                    </div>
                }
                <div style={{marginTop:'75px'}}>
                    {!isNullOrUndefined(this.state.enteredCompany) && this.state.enteredCompany.length>0 && this.state.userId.length==0?
                        <div style={{padding:'1em'}}>
                            <UserEmailAsk 
                                saveUserEmail = {this.setUser}
                                />
                        </div>
                        :
                        null
                    }
                    <div>
                        <MeetingV1Component
                            company = {this.state.enteredCompany}
                            userId = {this.state.userId}
                            />
                    </div>

                </div>
            </div>
        )
    }
}
export default PublicUserSessionComponent;

/*

    //Just before meeting component
    <h3 style={{textAlign:'left', marginLeft: '1em'}}>Enter meeting details</h3>
*/